// extracted by mini-css-extract-plugin
export var currencyInput = "_jl-1";
export var currencySymbol = "_jl-0";